export const woocommerce = {
  keyHelp:
    'The key can be found under "WooCommerce > Settings > Advanced > REST API"',
  secretHelp:
    'The secret can be found under "WooCommerce > Settings > Advanced > REST API"'
};
